import { module as BaseModule } from 'modujs';

export default class extends BaseModule {
	constructor(m) {
		super(m);
	}

	init() {
		const form = this.el;

	const DEFAULT_EXTRA_OFFSET = 0;

		function doScrollTo(el) {
			if (!el) return;
			try {
				if (window.lenis && typeof window.lenis.scrollTo === 'function') {
					const headerH = document.querySelector('header') ? document.querySelector('header').offsetHeight : 0;
					const scrollY = window.scrollY || window.pageYOffset || 0;
					let target = el.getBoundingClientRect().top + scrollY - headerH - 8;
					// Determinar offset (puede venir del propio elemento como data-scroll-offset)
					const dataOffset = parseInt(el.dataset.scrollOffset || el.getAttribute('data-scroll-offset'), 10);
					const offsetValue = !Number.isNaN(dataOffset) ? dataOffset : DEFAULT_EXTRA_OFFSET;
					// Aplicar offset extra para que el elemento quede más arriba
					target = target - offsetValue;
                    
					window.lenis.scrollTo(target, { duration: 1.0 });
					return;
				}
				// fallback: calcular la misma posición objetivo y usar window.scrollTo para controlar offset
				const headerH = document.querySelector('header') ? document.querySelector('header').offsetHeight : 0;
				const scrollY = window.scrollY || window.pageYOffset || 0;
				const dataOffset = parseInt(el.dataset.scrollOffset || el.getAttribute('data-scroll-offset'), 10);
				const offsetValue = !Number.isNaN(dataOffset) ? dataOffset : DEFAULT_EXTRA_OFFSET;
				let target = el.getBoundingClientRect().top + scrollY - headerH - 8 - offsetValue;
                
				window.scrollTo({ top: target, behavior: 'smooth' });
			} catch (err) {
				console.warn('[search.module] scroll error', err);
				try { el.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) { /* noop */ }
			}
		}

		function tryAndScroll() {
			const el = document.querySelector('.search-result');
			if (el) {
				// small delay to allow layout/images to settle
				setTimeout(() => doScrollTo(el), 80);
				return true;
			}
			return false;
		}

		// Intentar hacer scroll inmediatamente al cargar la página: si la plantilla
		// de resultados ya ha renderizado el contenedor #search-result, queremos
		// desplazarnos aunque no haya parámetros en la URL ni flag de submit.
		if (tryAndScroll()) {
			try { sessionStorage.removeItem('arts_search_submitted'); } catch (e) {}
			return;
		}

		// If not found yet, observe DOM for insertion (AJAX case)
		try {
			const mo = new MutationObserver((muts, obs) => {
				if (tryAndScroll()) {
					obs.disconnect();
					try { sessionStorage.removeItem('arts_search_submitted'); } catch (e) {}
				}
			});
			mo.observe(document.body, { childList: true, subtree: true });
			// safety disconnect
			setTimeout(() => { try { mo.disconnect(); } catch (e) {} }, 5000);
		} catch (e) {
			// fallback: retries
			let tries = 0;
			const interval = setInterval(() => {
				tries++;
				if (tryAndScroll() || tries > 10) { clearInterval(interval); try { sessionStorage.removeItem('arts_search_submitted'); } catch (e) {} }
			}, 250);
		}

	}
}	
